export default "__VITE_ASSET__4PCAH7nBbIBw3Gpj23tjgg__"